import { fromSpecific, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { AnyExpressionSpecific, MustacheNode } from '../Mustache'
import type { TypedSpecificLike } from '@rehaje/core'

export interface URLParameterSpecific extends TypedSpecificLike {
  /**
   * url 参数名称
   */
  name?: AnyExpressionSpecific | string
  type: 'URLParameter'
  /**
   * url 变量值来源
   */
  value?: AnyExpressionSpecific | string
}

export class URLParameterNode extends TypedNode {
  /**
   * url 参数名称
   */
  @fromSpecific()
  @reactive()
  name?: MustacheNode | string

  /**
   * url 变量来源
   */
  @fromSpecific()
  @reactive()
  value?: MustacheNode | string
}

declare global {
  export interface RehajeSpecifics {
    URLParameter: URLParameterSpecific
  }
  export interface RehajeTypedNodes {
    URLParameter: URLParameterNode
  }
}
